import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Dropdown } from '../../../components/Dropdown/Dropdown';
import { Popup } from '../../../components/Popup/popup';

import EditCategoryItemsLot from './item-edit';
import ViewDetailsCategoryItemsLot from './item-view';

import Multiselect from 'components/Multiselect';

import empty_icon from 'assets/img/empty-images.svg';
import * as LotActionType from '../../constants';

const FILTER_TYPES = [{ text: 'Inventory', value: 0 }, { text: 'MFG', value: 1 }];
const SCREEN_KEYS = {
  ListItems: 'list-items',
  ViewInventoryItems: 'view-inventory-items',
  EditInventoryItems: 'edit-inventory-items'
};

class ManageCategoryItemsLot extends Component {
  static propTypes = {
    lot: PropTypes.object,
    dispatch: PropTypes.func,
    location: PropTypes.any,
    history: PropTypes.any,
    itemList: PropTypes.array,
    inventoryList: PropTypes.array,
    onGetCategoryItemList: PropTypes.func
  }

  constructor(props) {
    super(props);

    this.queryParams = queryString.parse(location.search);
    this.itemId = this.queryParams.itemId;
    this.selectedInventoryId = this.queryParams.inventoryId;

    const defaultScreen = (this.itemId && SCREEN_KEYS.ViewInventoryItems) || SCREEN_KEYS.ListItems;

    this.state = {
      searchText: null,
      selectedInventories: [],
      groupingType: FILTER_TYPES[0],

      showFilterPopup: false,

      inventoryList: [],
      activeScreen: defaultScreen
    };

    if (this.itemId) {
      this.removeQueryParam('itemId');
    }

    if (this.selectedInventoryId) {
      this.removeQueryParam('inventoryId');
    }
  }

  componentDidMount() {
    this.getGroupList();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.inventoryList !== nextProps.inventoryList) {
      let list = nextProps.inventoryList.map(el => ({ label: el.name, value: el.id}));
      let selected = list.find(e => e.value === this.selectedInventoryId);
      this.setState({ selectedInventories: selected ? [selected] : [], inventoryList: list}, this.refreshList);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.lot && prevProps.lot.value !== this.props.lot.value) {
      this.onChangeLot();
    }
  }

  // services
  removeQueryParam = (...params) => {
    let queryParams = queryString.parse(location.search);

    params.forEach(key => delete queryParams[key]);
    this.props.history.push({
      pathname: location.pathname,
      search: queryString.stringify(queryParams)
    });
  }

  getGroupList = () => {
    const { lot } = this.props;
    const { builderProfile } = lot.extensionValue;

    this.props.dispatch({
      type: LotActionType.GET_LIST_CATEGORY_HOME_INVENTORY_HOME_OWNER_ASYNC,
      params: {
        lotId: lot.value,
        builderHost: builderProfile.builderHost,
        headers: {
          key: builderProfile.headerKey,
          value: builderProfile.securityToken
        }
      }
    });
  }

  getItemDetails = (itemId) => {
    const { builderProfile } = this.props.lot.extensionValue;

    this.props.dispatch({
      type: LotActionType.GET_CATEGORY_ITEM_HOME_INVENTORY_PROFILE_HOME_OWNER_ASYNC,
      params: {
        id: itemId,
        lotId: this.props.lot.value,
        builderHost: builderProfile.builderHost,
        headers: {
          key: builderProfile.headerKey,
          value: builderProfile.securityToken
        }
      }
    });
  }
  // end services

  // navigators
  goToEditScreen = () => {
    this.setState({activeScreen: SCREEN_KEYS.EditInventoryItems});
  }

  goToViewScreen = () => {
    this.setState({activeScreen: SCREEN_KEYS.ViewInventoryItems});
  }

  goToListScreenAndRefresh = () => {
    this.setState({activeScreen: SCREEN_KEYS.ListItems}, this.refreshList);
  }

  togglePopupFilter = () => {
    if (!this.state.showFilterPopup) {
      document.addEventListener('mousedown', this.checkMouseDownPosition, false);
    } else {
      document.removeEventListener('mousedown', this.checkMouseDownPosition, false);
    }

    this.setState({ showFilterPopup: !this.state.showFilterPopup });
  }
  // end navigators

  // user events
  onChangeLot = () => {
    this.setState({
      searchText: '',
      selectedInventories: [],
      groupingType: FILTER_TYPES[0],
      activeScreen: SCREEN_KEYS.ListItems
    },
    this.refreshList
    );
  }

  onPressEnter = (e) => {
    if (e.key === 'Enter') {
      this.onClickSearchButton(e);
    }
  }

  onClickSearchButton = () => {
    this.refreshList();
  }

  onChangeSearchTextbox = (e) => {
    this.setState({ searchText: e.target.value });
  }

  onChangeGroupByDropDown = (e) => {
    this.setState({ groupingType: e.value }, this.refreshList);
  }

  onChangeSelectedInventoryDropdown = (value) => {
    this.setState({ selectedInventories: value });
  }

  onClickOKFilter = () => {
    this.refreshList();
  }

  onClickOnItem = (id) => {
    this.itemId = id;
    this.setState({activeScreen: SCREEN_KEYS.ViewInventoryItems});
  }

  // end user events

  // helpers
  refreshList = () => {
    this.props.onGetCategoryItemList(this.getFilterParams());
  }

  getFilterParams = () => {
    const { builderProfile } = this.props.lot.extensionValue;

    return {
      lotId: this.props.lot.value,

      search: this.state.searchText,
      group: this.state.groupingType.value,
      categoryIds: this.state.selectedInventories.map(x => x.value),

      builderHost: builderProfile.builderHost,
      headerKey: builderProfile.headerKey,
      securityToken: builderProfile.securityToken
    };
  }

  checkMouseDownPosition = (e) => {
    if (!this.showCategoryFilter.contains(e.target)) {
      this.togglePopupFilter();
    }
  }
  // end helpers

  renderHeaderSection = () => {
    const { searchText, inventoryList, selectedInventories, groupingType, showFilterPopup: popupFilter } = this.state;

    return (
      <React.Fragment>
        <div className='row'>
          <div className='group-function-inventory-item col-md-9 col-xs-6' style={{ paddingLeft: 0, paddingRight: 0 }}>
            <div className='groupby-inventory-item'>
              <span className='group-by-category-items'>Group by</span>
              <Dropdown
                className='filestring-dropdown filter-dropdown'
                value={groupingType}
                options={FILTER_TYPES}
                style={{ width: '70%', display: 'table-cell' }}
                optionLabel='text'
                onChange={this.onChangeGroupByDropDown}
                ref={ref => { this.combobox = ref; }} />
            </div>
            <div className={popupFilter ? 'filter-button-category-items-selected' : 'filter-button-category-items'}
              style={{ display: 'table-cell', width: 40, textAlign: 'center' }}>
              <button
                style={{ fontSize: 20, width: 40, height: 20, paddingLeft: 9, borderRadius: '50%', border: 'none' }}
                onClick={this.togglePopupFilter} className='btn btn-secondary fa fa-filter btn-icon' id='popup-button'
              />
            </div>
            {
              this.state.showFilterPopup &&
              <Popup styles={{ width: 400, left: 140, minHeight: 200, top: 10 }}>
                <div className='container-fluid' ref={(ref) => { this.showCategoryFilter = ref; }}>
                  <h5>Filters</h5>
                  <label style={{ marginBottom: 5 }} className='title'>Inventory</label>
                  <Multiselect
                    items={inventoryList}
                    value={selectedInventories}
                    onRemote={this.getGroupList}
                    onChange={this.onChangeSelectedInventoryDropdown}
                    className='filestring-dropdown filter-dropdown'
                    filter={true}
                    placeholder='Select Any'
                    ref={ref => { this.categoryDropdown = ref; }} />
                  <button onClick={this.onClickOKFilter} className='btn btn-siteone btn-primary'>OK</button>
                </div>
              </Popup>
            }
          </div>
          <div className='col-md-3 col-xs-6'>
            <div className='box-search' style={{ margin: 0, transform: 'translateY(5px)' }} >
              <div className='input-group'>
                <input
                  type='text' id='txt-search-email' ref={ref => { this.search = ref; }} value={searchText || ''}
                  onChange={this.onChangeSearchTextbox} className='form-control' placeholder='Search by name' onKeyPress={this.onPressEnter} />
                <span className='input-group-btn'>
                  <button onClick={this.onClickSearchButton} className='btn btn-secondary'
                    style={{ padding: '4px 10px', fontSize: 16, backgroundColor: '#ececec', border: '0.5px solid #d8d8d8', height: 40 }}>
                    <span className='fa fa-search' aria-hidden='true' />
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderItemList = () => {
    const { itemList } = this.props;

    if (itemList && itemList.length === 0) {
      if (!this.state.searchText && !this.state.selectedInventories.length) {
        return (
          <React.Fragment>
            <div style={{ textAlign: 'center', margin: '5%' }} className='row'>
              <div className='col-md-12 col-xs-12'>
                <img
                  src='/images/empty-dashboard_bw.png'
                  alt='s1-empty-dashboard'
                  style={{ width: 485, opacity: 0.8 }}
                />
              </div>
              <div className='col-md-12 col-xs-12'>
                <h3 style={{ fontSize: 20 }}>No inventory items, yet.</h3>
              </div>
            </div>
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment>
            {this.renderHeaderSection()}
            <div className='row'>
              <div className='col-md-12 col-xs-12'>
                <p style={{ marginTop: 25, textAlign: 'center' }}>There are no results</p>
              </div>
            </div>
          </React.Fragment>
        );
      }
    }
    else {
      return (
        <React.Fragment>
          {itemList && this.renderHeaderSection()}
          {itemList && itemList.map(category => {
            return (
              <React.Fragment>
                <div className='row'>
                  <div className='col-md-12 col-xs-12'>
                    <h4 className='title' style={{ marginTop: 15, marginBottom: 5, fontWeight: 'bold' }}>{category.group}</h4>
                  </div>
                  {category && category.items.map(item => {
                    return (
                      <div key={item.id} style={{ marginBottom: 15 }} className='col-xs-4 col-lg-3'>
                        <div className='category-list-items'>
                          <div style={{ marginBottom: 10 }} className='category-list-item-wrapper'>
                            <div className='document-thumbnail-wrapper thumbnail-wrapper-item'>
                              <img style={{ width: '100%', height: 170, objectFit: 'contain' }} src={item.thumbnail && item.thumbnail.thumbnailUrl ? item.thumbnail.thumbnailUrl : empty_icon} />
                              <div onClick={() => this.onClickOnItem(item.id)} className='document-fade' />
                            </div>
                          </div>
                          <div style={{ display: 'grid', justifyContent: 'left' }} onClick={() => this.onClickOnItem(item.id)} className='category-list-items-project-name'>
                            <div className='category-name col-md-12 col-sm-12'>
                              <div className='over-flow-text'>{item.name}</div>
                              <div className='over-flow-text' style={{ color: 'lightgray' }}>Model #{item.model}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </React.Fragment>
            );
          })
          }
        </React.Fragment>
      );
    }
  }

  render() {
    return (
      <div className='manage-category-container container-fluid'>
        {
          this.state.activeScreen === SCREEN_KEYS.ListItems &&
          this.renderItemList()
        }

        {
          this.state.activeScreen === SCREEN_KEYS.ViewInventoryItems &&
          <ViewDetailsCategoryItemsLot
            itemId={this.itemId}
            onGetCategoryItemProfile={this.getItemDetails}
            goToEditScreen={this.goToEditScreen}
            goToListScreen={this.goToListScreenAndRefresh}
          />
        }
        {
          this.state.activeScreen === SCREEN_KEYS.EditInventoryItems &&
          <EditCategoryItemsLot
            lot={this.props.lot}
            categoryItemId={this.itemId}
            onGetCategoryItemProfile={this.getItemDetails}
            goToViewScreen={this.goToViewScreen}
            goToListScreen={this.goToListScreenAndRefresh}
          />
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    itemList: state.LotStore.categoryItemList,
    inventoryList: state.LotStore.categoryList
  };
};

export default withRouter(connect(mapStateToProps)(ManageCategoryItemsLot));



// WEBPACK FOOTER //
// ./src/Lots/Components/Inventory/item-list.js